module.exports = __webpack_public_path__ + "img/Verpflegungszug.8f8356b6.svg";